export const SEARCH_RESULTS_PER_PAGE = 50;
export const RESUME_SEARCH_STORAGE_KEY = 'user_resume_search_enabled';
